import React from 'react';
import clsx from 'clsx';
import { Theme } from '@material-ui/core/styles';
import createStyles from '@material-ui/styles/createStyles';
import makeStyles from '@material-ui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    buttonWrapper: {
      display: 'flex',
      alignItems: 'center',
      marginTop: 29,
      [theme.breakpoints.down('xs')]: {
        justifyContent: 'center',
        margin: '21px 0 13px',
      },
    },
  }),
);

interface Props {
  children: React.ReactNode;
  className?: string;
}

const ButtonWrapper: React.FC<Props> = (props: Props) => {
  const { children, className } = props;
  const classes = useStyles();

  return (
    <div className={clsx(classes.buttonWrapper, className)} data-cy="button-wrapper">
      {children}
    </div>
  );
};

export default ButtonWrapper;
